export const CHIP_COLOURS = {
  type: 'bg-violet-50 text-violet-500 border-violet-200',
  issue: 'bg-blue-50 text-blue-500 border-blue-200',
  extension: 'bg-gray-100 text-gray-600 border-gray-200',
};
